<template>
  <button
    aria-selected="false"
    type="button"
    role="option"
    :disabled="disabled"
    class="flex w-full items-center rounded-md p-3 transition-[box-shadow_background_color] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1"
    :class="disabled ? schemeClass.disabled : selected ? schemeClass.selected : schemeClass.default"
  >
    <slot>
      <div class="flex items-center gap-x-1">
        <gv-icon v-if="icon" :name="icon" size="sm" />

        <gv-type wrap="nowrap" scheme="custom">
          {{ text }}
        </gv-type>
      </div>
    </slot>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Scheme } from './types';

type Classes = {
  default: string;
  selected: string;
  disabled: string;
};

const props = withDefaults(
  defineProps<{
    scheme?: Scheme;
    text?: string;
    icon?: string;
    disabled?: boolean;
    selected?: boolean;
  }>(),
  {
    scheme: 'primary',
    disabled: false,
    selected: false,
  }
);

const schemeClasses: Record<Scheme, Classes> = {
  primary: {
    default: 'text-type-secondary hover:bg-grey-25 hover:text-type-primary focus-visible:ring-primary',
    selected: 'bg-grey-50 text-type-primary focus-visible:ring-primary',
    disabled: 'text-type-tertiary',
  },
  dark: {
    default: 'text-grey-100 bg-grey-700 hover:bg-grey-600 focus-visible:ring-grey-600',
    selected: 'text-grey-100 bg-grey-600',
    disabled: 'text-type-tertiary bg-grey-600',
  },
  error: {
    default: 'text-status-error hover:bg-status-error-bg focus-visible:ring-status-error',
    selected: 'bg-status-error-bg text-status-error focus-visible:ring-status-error',
    disabled: 'text-type-tertiary',
  },
};

const schemeClass = computed(() => schemeClasses[props.scheme]);
</script>
